import * as React from "react";
import { actionCreators } from "page/calendar/store";
import { SpiralItem, CalendarState } from "burde";
import ZentaColorPicker, {
    ZentaColorPickerItem,
} from "layout/common/controls-area/zenta-color-picker";
import { DefaultSpiralsList } from "ui/constants";
import * as styles from "./cover-spiral-picker.css";

type CoverSpiralPickerProps = {
    validSpirals: Array<SpiralItem>;
    calendar: CalendarState;
    Binding_Spiral: string;
} & typeof actionCreators;

interface CoverSpiralPickerState {
    defaultSpiral: SpiralItem | null;
}

class CoverSpiralPicker extends React.Component<
    CoverSpiralPickerProps,
    CoverSpiralPickerState
> {
    state: CoverSpiralPickerState = {
        defaultSpiral: null,
    };

    private changeSpiral = (selectedSpiralId: number) => {
        const selected = this.props.validSpirals.find(
            (x) => x.id === selectedSpiralId,
        );

        if (!selected) {
            return;
        }

        this.props.updateSpiral(selected.articleNumber);
    };

    private setDefaultSpiral = () => {
        const { calendar, validSpirals } = this.props;

        const defaultSpiral = DefaultSpiralsList.find(
            (x) => x.calendarSize === this.props.calendar.calendarSize,
        );

        if (defaultSpiral !== undefined) {
            this.setState({ defaultSpiral: defaultSpiral.value });

            const spiralArticleNumber = calendar.spiral;

            const selectedSpiral = validSpirals.find(
                (x) => x.articleNumber == spiralArticleNumber,
            );

            if (selectedSpiral == undefined) {
                this.props.updateSpiral(defaultSpiral.value.articleNumber);
            }
        }
    };

    componentDidMount() {
        const { validSpirals } = this.props;

        if (validSpirals.length > 0) {
            this.setDefaultSpiral();
        }
    }

    componentDidUpdate(prevProps: CoverSpiralPickerProps) {
        // When valid spirals have been set, see if the currently
        // selected spiral is valid and update it otherwise.
        if (
            prevProps.validSpirals.length == 0 &&
            this.props.validSpirals.length > 0 &&
            this.state.defaultSpiral == null
        ) {
            this.setDefaultSpiral();
        }
    }

    public render() {
        const { calendar, validSpirals, Binding_Spiral } = this.props;

        const spiral = calendar.spiral;

        const getHexColor = () => {
            if (!spiral) {
                return "";
            }

            let selectedItem = validSpirals.find(
                (x) => x.articleNumber === spiral,
            );

            if (!selectedItem) {
                return "";
            }

            return selectedItem.id;
        };

        return (
            <>
                <label className={styles.subLabel}>{Binding_Spiral}</label>
                <ZentaColorPicker
                    colors={validSpirals.map(
                        (x) =>
                            ({
                                id: x.id,
                                hexColor: x.hexColor,
                                applyGradient: x.isMetalic,
                            } as ZentaColorPickerItem),
                    )}
                    onClick={this.changeSpiral}
                    applyGradient={true}
                    selectedItemId={getHexColor()}
                    colorsWithBorder={[2]}
                />
            </>
        );
    }
}

export default CoverSpiralPicker;
